module.exports = __webpack_public_path__ + "static/media/phone.5ebfa455.svg";